import React, { FunctionComponent, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { GreenBtn, GreyBtnDisabled } from 'Stories/Button/Button.stories'
import { Desktop, Mobile } from 'Shared/components/Responsive'
import { ModalSubHeader } from 'Stories/ModalSubHeader/ModalSubHeader.stories'
import SearchInput from 'Containers/ui/Input'

import AlertErrorMessageWithIcon from 'Shared/components/AlertErrorMessageWithIcon'
import {
  AddSearchTrackFormProps,
  FormDataProps,
} from './AddSearchTrackFormProps'

import {
  HorizontalLine,
  ModalSubHeaderWrapper,
  SearchForm,
  SearchFormBtnBlock,
  SearchFormContainer,
} from './styles'

const AddSearchTrackForm: FunctionComponent<AddSearchTrackFormProps> = ({
  searchValue,
  searchError,
  errorAnswerSpotify,
  sameTrackError,
  setSearchValue,
  onSubmit,
}) => {
  const { t } = useTranslation()

  const { register, watch, handleSubmit } = useForm<FormDataProps>({
    mode: 'onChange',
  })
  const watchSearchInput = watch('searchInput', '')
  const watchSearchInputLenght = watchSearchInput && watchSearchInput.length

  useEffect(() => {
    setTimeout(() => window.scrollTo(0, 0), 200)
  }, [])

  const ScrollToTop = () => {
    const { pathname } = useLocation()

    useEffect(() => {
      window.scrollTo(0, 0)
    }, [pathname])

    return null
  }

  return (
    <>
      <Desktop>
        <SearchForm onSubmit={handleSubmit(onSubmit)}>
          <SearchFormContainer>
            <div>
              <ModalSubHeaderWrapper>
                <ModalSubHeader
                  content={t(
                    'createCampaignPage.typeYourTrackNameOrInsertALink'
                  )}
                />
              </ModalSubHeaderWrapper>
              <SearchInput
                required
                autoFocus
                {...register('searchInput')}
                id="searchInput"
                name="searchInput"
                type="text"
                value={searchValue}
                // @ts-ignore
                onChange={e => setSearchValue(e.target.value)}
              />
              <AlertErrorMessageWithIcon
                type="desktop"
                isShow={searchError}
                errorText={t(
                  'createCampaignPage.oopsWeHaveAnIssueHerePleaseReloadPage'
                )}
              />
              <AlertErrorMessageWithIcon
                type="desktop"
                isShow={errorAnswerSpotify}
                errorText={t(
                  'createCampaignPage.sorrySpotifyIsNotRespondingPleaseTryAgainLater'
                )}
              />
              <AlertErrorMessageWithIcon
                type="desktop"
                isShow={sameTrackError}
                errorText={t('createCampaignPage.sameTrackError')}
              />
            </div>
            {/* <SearchFormBtnBlock>
              {watchSearchInputLenght === 0 ||
              sameTrackError ||
              searchError ||
              errorAnswerSpotify ? (
                <GreyBtnDisabled
                  // @ts-ignore
                  disabled
                  color="greyDisabled"
                >
                  {t('createCampaignPage.searchTrack')}
                </GreyBtnDisabled>
              ) : (
                <GreenBtn
                  color="green"
                  // @ts-ignore
                  type="button"
                >
                  {t('createCampaignPage.searchTrack')}
                </GreenBtn>
              )}
            </SearchFormBtnBlock> */}
          </SearchFormContainer>
        </SearchForm>
      </Desktop>

      <Mobile>
        <SearchForm onSubmit={handleSubmit(onSubmit)}>
          <ScrollToTop />
          <SearchFormContainer>
            <SearchInput
              placeholder={t('createCampaignPage.startTypingYourTrack')}
              required
              autoFocus
              autoComplete="off"
              {...register('searchInput')}
              id="searchInput"
              name="searchInput"
              type="text"
              value={searchValue}
              // @ts-ignore
              onChange={e => setSearchValue(e.target.value)}
            />
          </SearchFormContainer>
          <HorizontalLine />
        </SearchForm>
      </Mobile>
    </>
  )
}
export default AddSearchTrackForm
